import { ToWords } from 'to-words';

export const MoneyFormat = (number) => {
    const { FormatMoney } = require('format-money-js');
    const fm = new FormatMoney({
        decimals: 2
    });
    const convertedData = fm.from(number?number:0);
    return convertedData;
}


export const NumberToWord = (number) => {
    const toWords = new ToWords();
    const words = toWords.convert(number?number:0);
    return words;
}

export const NumberToNepaliNum = (number)=>{
    const nepaliNumber = require('nepali-number')
   const convert_num = nepaliNumber.englishToNepaliNumber(number, "ne");
   return convert_num;
}


export const NumNepali=(number)=>{
    const numWords = require('num-words');
    const Result =numWords(number?number:0);
    return Result;
}